<!-- eslint-disable vuejs-accessibility/label-has-for -->

<template>
  <div>
    <div class="contenedor-rectangulo">
      <h1 class="titulo-tarjeta">Acta Entrega titular leasing operativo</h1>
      <!-- Tarjeta Datos -->
      <div class="tarjeta" style="border-left: 4px solid black">
        <form class="form-codigo-datos" @submit.prevent="buscarDatos">
          <div class="campo">
            <label for="unidadInput" class="campo-label">Ingrese código/patente auto:</label>
            <span class="campo-valor">
              <input
                id="unidadInput"
                v-model="auto"
                type="text"
                @input="auto = $event.target.value.toUpperCase()"
              />
            </span>
          </div>

          <div class="campo-boton">
            <button
              type="submit"
              class="boton boton--buscar"
              :disabled="!puedeBuscar"
              :class="{ 'boton-deshabilitado': !puedeBuscar }"
            >
              Buscar datos
            </button>
          </div>
        </form>

        <!-- Items Checklist -->
        <div v-if="response && mostrarTarjetas" class="campos-container">
          <!-- Patente unidad -->
          <div class="tarjeta">
            <div class="campo" style="margin-left: 1rem; grid-template-columns: 10rem 1fr">
              <label class="campo-label">Patente unidad:</label>
              <span class="campo-valor" style="margin-left: 0.6rem">{{
                response.Auto?.Placa || ""
              }}</span>
            </div>
          </div>

          <!-- Marca unidad -->
          <div class="tarjeta">
            <div class="campo" style="margin-left: 1rem; grid-template-columns: 10rem 1fr">
              <label class="campo-label">Marca unidad:</label>
              <span class="campo-valor" style="margin-left: 0.6rem">{{
                response.Auto?.AutoModel.Marca || ""
              }}</span>
            </div>
          </div>

          <!-- Modelo unidad -->
          <div class="tarjeta">
            <div class="campo" style="margin-left: 1rem; grid-template-columns: 10rem 1fr">
              <label class="campo-label">Modelo unidad:</label>
              <span class="campo-valor" style="margin-left: 0.6rem">{{
                response.Auto?.AutoModel.Modelo || ""
              }}</span>
            </div>
          </div>

          <!-- Color unidad -->
          <div class="tarjeta">
            <div class="campo" style="margin-left: 1rem; grid-template-columns: 10rem 1fr">
              <label class="campo-label">Color unidad:</label>
              <span class="campo-valor" style="margin-left: 0.6rem">{{
                response.Auto?.Color || ""
              }}</span>
            </div>
          </div>

          <!-- Email cliente -->
          <div class="tarjeta">
            <div class="campo" style="margin-left: 1rem; grid-template-columns: 10rem 1fr">
              <label class="campo-label">Email firmante:</label>
              <input
                v-if="response?.Cliente"
                style="margin-left: 0.6rem; width: 80%"
                class="campo-valor"
                v-model="emailCliente"
              />
            </div>
          </div>

          <!-- Rut cliente -->
          <div class="tarjeta">
            <div class="campo" style="margin-left: 1rem; grid-template-columns: 10rem 1fr">
              <label class="campo-label">Rut cliente:</label>
              <input
                style="margin-left: 0.6rem; width: 80%"
                class="campo-valor"
                v-model="rutCliente"
                placeholder="Rut sin puntos y con guión"
              />
            </div>
          </div>

          <!-- Chequeo torque -->
          <div class="tarjeta" style="padding: 0.3rem 1rem">
            <div
              class="campo"
              style="grid-template-columns: 1.5fr auto; align-items: center; gap: 1rem"
            >
              <label class="campo-label" style="white-space: normal; word-wrap: break-word"
                >El torque de las tuercas de las ruedas de mi vehiculo fueron revisadas en mi
                presencia y estoy conforme</label
              >
              <input type="checkbox" v-model="checkbox" class="checkbox-personalizado" />
            </div>
          </div>
        </div>
        <div
          v-if="mensajeEstado"
          :class="mensajeEstado.tipo === 'error' ? 'mensaje-error' : 'mensaje-ok'"
          style="margin-top: 1rem"
        >
          {{ mensajeEstado.texto }}

          <ul class="lista-incompleta" v-if="elementosIncompletos.length">
            <li v-for="(item, index) in elementosIncompletos" :key="index">
              <span class="texto-item">{{ item.item }}</span>
            </li>
          </ul>
        </div>
      </div>

      <!-- Firma y botones -->
      <button
        type="button"
        class="boton boton--reset"
        :disabled="!resetFormulario"
        :class="{ 'boton-deshabilitado': !resetFormulario }"
        @click="resetearFormulario"
      >
        Limpiar formulario
      </button>
      <!-- Tarjeta Firma -->
      <div class="tarjeta" style="border-left: 4px solid black">
        <label style="margin-top: 0.5rem; margin-bottom: 0.5rem; font-weight: bold"
          >Firma del cliente:</label
        >
        <canvas
          ref="firmaCanvas"
          class="firma-box"
          :class="{ 'firma-deshabilitada': firmaBloqueada }"
          width="400"
          height="200"
          @mousedown="startFirma"
          @mousemove="drawFirma"
          @mouseup="endFirma"
          @mouseleave="endFirma"
          @blur="endFirma"
          @touchstart.prevent="startFirmaTouch"
          @touchmove.prevent="drawFirmaTouch"
          @touchend.prevent="endFirma"
          :style="{
            pointerEvents: firmaBloqueada ? 'none' : 'auto',
            opacity: firmaBloqueada ? 0.5 : 1,
          }"
        ></canvas>
      </div>

      <button
        type="button"
        class="boton-resetear-firma"
        :disabled="!resetFirma"
        :class="{ 'boton-deshabilitado': !resetFirma }"
        @click="limpiarFirma"
      >
        Limpiar firma
      </button>

      <button
        type="button"
        class="boton boton--enviar"
        :disabled="enviarDeshabilitado || enviando"
        :class="{ 'boton-deshabilitado': enviarDeshabilitado || enviando }"
        @click="enviarActa"
      >
        {{ enviando ? "Enviando..." : "Enviar" }}
      </button>
    </div>
  </div>
</template>

<script setup>
/* eslint-disable */
import { ref, computed, onMounted, watch } from "vue";
import { axiosRequest } from "../Api/axios";

const auto = ref("");
const rutCliente = ref("");
const mensajeError = ref("");
const tieneFirma = ref(false);
const response = ref(null);
const checkbox = ref(false);
const errorForzado = ref("");
const emailCliente = ref("");
const servidorDisponible = ref(true);
const enviando = ref(false);

async function buscarDatos() {
  mensajeError.value = "";
  errorForzado.value = "";
  rutCliente.value = "";
  checkbox.value = false;
  tieneFirma.value = false;
  limpiarFirma();

  try {
    const responseData = await axiosRequest(`/servicios/getCheckList`, {
      auto: auto.value.toUpperCase(),
    });

    response.value = responseData;

    emailCliente.value = responseData?.Cliente?.email || "";
  } catch (error) {
    response.value = null;

    if (error.response) {
      errorForzado.value =
        error.response.data?.mensaje ||
        "Error de conexión con el servidor. Favor comunicarse con soporte.";
    } else {
      errorForzado.value =
        "El servidor no responde. Intente nuevamente más tarde. Favor comunicarse con soporte.";
    }
  }
}

async function enviarActa() {
  errorForzado.value = "";

  if (enviando.value) return;

  if (!servidorDisponible.value) {
    errorForzado.value = "El servidor no está disponible. Favor comunicarse con soporte.";
    return;
  }

  if (firmaBloqueada.value) return;

  if (!auto.value || auto.value.trim() === "") {
    errorForzado.value = "Debe ingresar el código del auto antes de enviar.";
    return;
  }

  if (!response.value) {
    errorForzado.value = "Debe buscar los datos antes de enviar el acta.";
    return;
  }

  if (!tieneFirma.value) {
    errorForzado.value = "Debe firmar el acta antes de enviarla.";
    return;
  }

  const datosParaEnvio = {
    unidad: auto.value.toUpperCase(),
    emailCliente: emailCliente.value || "",
    rutCliente: rutCliente.value,
    firma: obtenerFirmaBase64(),
    OT: response.value?.OT || "",
    idAltaLop: response.value?.idAltaLop || "",
  };

  enviando.value = true;

  try {
    const respuesta = await axiosRequest(`/servicios/altaLop`, datosParaEnvio);

    servidorDisponible.value = true;
    errorForzado.value = "";

    if (respuesta?.ok === true) {
      alert("El acta se ha enviado correctamente.");
      resetearFormulario();
    } else {
      errorForzado.value = respuesta?.mensaje || "Error al enviar el acta.";
    }
  } catch (error) {
    if (error.response) {
      servidorDisponible.value = true;

      errorForzado.value =
        error.response.data?.mensaje ||
        "Error de conexión con el servidor. Favor comunicarse con soporte.";
    } else {
      servidorDisponible.value = false;

      errorForzado.value =
        "El servidor no respondió. El acta no fue enviada. Favor comunicarse con soporte.";
    }

    console.error("Error enviarActa:", error);
  } finally {
    enviando.value = false;
  }
}

const firmaCanvas = ref(null);
let dibujando = false;
let lastX = 0;
let lastY = 0;

onMounted(() => {
  actualizarFondoCanvas();
});

function getPos(e) {
  const canvas = firmaCanvas.value;
  const rect = canvas.getBoundingClientRect();
  const scaleX = canvas.width / rect.width;
  const scaleY = canvas.height / rect.height;

  return {
    x: (e.clientX - rect.left) * scaleX,
    y: (e.clientY - rect.top) * scaleY,
  };
}

function getTouchPos(e) {
  const canvas = firmaCanvas.value;
  const rect = canvas.getBoundingClientRect();
  const touch = e.touches[0];
  const scaleX = canvas.width / rect.width;
  const scaleY = canvas.height / rect.height;

  return {
    x: (touch.clientX - rect.left) * scaleX,
    y: (touch.clientY - rect.top) * scaleY,
  };
}

function startFirma(e) {
  if (firmaBloqueada.value) return;
  dibujando = true;
  const pos = getPos(e);
  lastX = pos.x;
  lastY = pos.y;

  const ctx = firmaCanvas.value.getContext("2d");
  ctx.fillStyle = "#222";
  ctx.beginPath();
  ctx.arc(pos.x, pos.y, 2, 0, 2 * Math.PI);
  ctx.fill();

  tieneFirma.value = true;
}

function drawFirma(e) {
  if (!dibujando || firmaBloqueada.value) return;
  const ctx = firmaCanvas.value.getContext("2d");
  ctx.strokeStyle = "#222";
  ctx.lineWidth = 2;
  ctx.lineCap = "round";
  const pos = getPos(e);
  ctx.beginPath();
  ctx.moveTo(lastX, lastY);
  ctx.lineTo(pos.x, pos.y);
  ctx.stroke();
  lastX = pos.x;
  lastY = pos.y;

  tieneFirma.value = true;
}

function endFirma() {
  dibujando = false;
}

function startFirmaTouch(e) {
  if (firmaBloqueada.value) return;
  dibujando = true;
  const pos = getTouchPos(e);
  lastX = pos.x;
  lastY = pos.y;

  const ctx = firmaCanvas.value.getContext("2d");
  ctx.fillStyle = "#222";
  ctx.beginPath();
  ctx.arc(pos.x, pos.y, 2, 0, 2 * Math.PI);
  ctx.fill();

  tieneFirma.value = true;
}

function drawFirmaTouch(e) {
  if (!dibujando || firmaBloqueada.value) return;
  const ctx = firmaCanvas.value.getContext("2d");
  ctx.strokeStyle = "#222";
  ctx.lineWidth = 2;
  ctx.lineCap = "round";
  const pos = getTouchPos(e);
  ctx.beginPath();
  ctx.moveTo(lastX, lastY);
  ctx.lineTo(pos.x, pos.y);
  ctx.stroke();
  lastX = pos.x;
  lastY = pos.y;

  tieneFirma.value = true;
}

function actualizarFondoCanvas() {
  if (!firmaCanvas.value) return;
  const ctx = firmaCanvas.value.getContext("2d");
  ctx.clearRect(0, 0, firmaCanvas.value.width, firmaCanvas.value.height);
  ctx.fillStyle = firmaBloqueada.value ? "#808080" : "#fafafa";
  ctx.fillRect(0, 0, firmaCanvas.value.width, firmaCanvas.value.height);
}

function limpiarFirma() {
  const ctx = firmaCanvas.value.getContext("2d");
  ctx.clearRect(0, 0, firmaCanvas.value.width, firmaCanvas.value.height);
  ctx.fillStyle = firmaBloqueada.value ? "#808080" : "#fafafa";
  ctx.fillRect(0, 0, firmaCanvas.value.width, firmaCanvas.value.height);

  tieneFirma.value = false;
}

function obtenerFirmaBase64() {
  if (!firmaCanvas.value) return null;
  const dataURL = firmaCanvas.value.toDataURL("image/png");
  return dataURL.split(",")[1];
}

function resetearFormulario() {
  auto.value = "";
  rutCliente.value = "";
  mensajeError.value = "";
  tieneFirma.value = false;
  response.value = null;
  checkbox.value = false;

  limpiarFirma();
}

function validarRut(rut) {
  if (!rut) return false;

  // Limpiar puntos y pasar a mayúscula
  const rutLimpio = rut.replace(/\./g, "").toUpperCase();

  // Validar formato básico
  if (!/^\d{7,8}-[\dK]$/.test(rutLimpio)) return false;

  const [numero, dv] = rutLimpio.split("-");
  let suma = 0;
  let multiplicador = 2;

  for (let i = numero.length - 1; i >= 0; i--) {
    suma += parseInt(numero[i]) * multiplicador;
    multiplicador = multiplicador === 7 ? 2 : multiplicador + 1;
  }

  const resto = 11 - (suma % 11);
  let dvEsperado = "";

  if (resto === 11) dvEsperado = "0";
  else if (resto === 10) dvEsperado = "K";
  else dvEsperado = resto.toString();

  return dv === dvEsperado;
}

const mostrarTarjetas = computed(() => {
  return response.value && response.value.Auto && response.value.Auto.Lease;
});

const mensajeEstado = computed(() => {
  if (errorForzado.value) {
    return {
      texto: errorForzado.value,
      tipo: "error",
    };
  }

  if (!response.value) return "";

  if (response.value.ok === false && response.value.mensaje) {
    return {
      texto: response.value.mensaje,
      tipo: "error",
    };
  }

  if (response.value.ok === true) {
    return {
      texto: "Unidad lista para alta LOP",
      tipo: "ok",
    };
  }

  return "";
});

const puedeBuscar = computed(() => {
  return auto.value && auto.value.trim() !== "";
});

const enviarDeshabilitado = computed(() => {
  return firmaBloqueada.value || !tieneFirma.value || !rutCliente.value;
});

const firmaBloqueada = computed(() => {
  if (!response.value || response.value.ok !== true) {
    return true;
  }

  // Bloquear si el rut ingresado no es un rut válido
  if (!validarRut(rutCliente.value)) {
    return true;
  }

  // Bloquear si no hay email válido o no pusieron correo
  if (
    !emailCliente.value ||
    emailCliente.value.trim() === "" ||
    !emailCliente.value.includes("@")
  ) {
    return true;
  }

  // Bloquear si no ha seleccionado el checkbox
  if (!checkbox.value) {
    return true;
  }

  return false;
});

const resetFirma = computed(() => {
  return !firmaBloqueada.value && tieneFirma.value;
});

const resetFormulario = computed(() => {
  return response.value !== null || checkbox.value;
});

const elementosIncompletos = computed(() => {
  if (!response.value || !response.value.data) return [];

  try {
    const parsed = JSON.parse(response.value.data);
    if (!Array.isArray(parsed)) return [];

    return parsed.filter((item) => item.realizado === false);
  } catch (e) {
    console.error("Error parseando data:", e);
    return [];
  }
});

watch(
  firmaBloqueada,
  () => {
    actualizarFondoCanvas();
  },
  { immediate: false }
);
</script>

<style scoped>
@import "../css/home.css";
</style>
